import { useQuery } from '@apollo/client'
import { Alert, Typography } from '@mui/material'
import { CandidateInterviewBucketQuery } from 'candidate/graphql/candidate.gql'
import React, { useState } from 'react'
import { PopupButton } from 'shared/components/Calendly'
import { ButtonContainer, popupButtonStyles } from './styled'

const SchedulingBanner: React.FC = () => {
    const [schedulingLink, setSchedulingLink] = useState<string | null>()

    useQuery(CandidateInterviewBucketQuery, {
        fetchPolicy: 'network-only',
        onCompleted(data) {
            setSchedulingLink(
                data.candidateInterviewBucket?.candidateInterviewLink
            )
        },
    })

    return (
        <>
            {schedulingLink && (
                <Alert variant="filled" severity="info">
                    <ButtonContainer>
                        <Typography
                            style={{ flexGrow: 1, marginRight: '12rem' }}
                        >
                            You've been selected to schedule a screen call!
                            Please schedule a time that works best for you.
                        </Typography>
                        <PopupButton
                            url={schedulingLink}
                            rootElement={document.getElementById('root')!}
                            text="Schedule screening call"
                            styles={popupButtonStyles}
                        />
                    </ButtonContainer>
                </Alert>
            )}
        </>
    )
}

export default SchedulingBanner
